module.exports = __webpack_public_path__ + "static/media/Photo4.be244ae5.png";